import React from "react";

export const CircleTipProgressBar = ({
  width,
  label = null,
  hasPassed = false,
}) => {
  return (
    <div className="circle-progress-bar">
      <div className="progress-track">
        <div
          className={`progress-highlight ${!hasPassed ? "" : "failed"}`}
          style={{
            width: `${width}%`,
          }}
        >
          <div className="progress-end-circle">
            {label && (
              <p
                className={`progress-label-txt ${
                  label.length > 5 ? "font-9" : ""
                }`}
              >
                {label}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
